export type Language = { Name: string, Code: string }

export const languages = [{ Name: "لعربية ", Code: "ar-SA" },
{ Name: "Čeština", Code: "cs-CZ" },
{ Name: "English (United States)", Code: "en-US" },
{ Name: "English (Australia)", Code: "en-AU" },
{ Name: "English (United Kingdom)", Code: "en-GB" },
{ Name: "Español (España)", Code: "es-ES" }
] as Language[];
